import axios from 'axios';
import React, { Fragment, useEffect, useState } from 'react';
import { IoMdArrowRoundBack } from 'react-icons/io';
import { HiShoppingBag } from "react-icons/hi2";
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';

function MyOrdersPage() {
    const [orderData, setOrderData] = useState([]);
    const navigate = useNavigate();
    const API_URL = process.env.REACT_APP_API_URL;
    const mobile = localStorage.getItem('mobile');

    useEffect(() => {
        if (!mobile) {
            toast.error("Login to view orders");
            setTimeout(() => navigate('/user-login'), 2000);
            return;
        }
        
        const handleOrderData = async () => {
            try {
                const response = await axios.get(`${API_URL}/order-data/${mobile}`);
                const sortedOrders = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)); // Sorting by newest first
                setOrderData(sortedOrders || []);
            } catch (err) {
                toast.error("Failed to fetch orders. Please try again.");
            }
        };
    
        handleOrderData();
    }, [mobile, navigate]);    

    return (
        <Fragment>
            <div className="container-fluid m-t25">
                <div className="row">
                    <div className="col-12 cat-strip border shadow-sm">
                        <div>
                            <button onClick={() => navigate(-1)}><IoMdArrowRoundBack /></button>
                            <label>MY ORDERS</label>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-12 col-sm-12 col-md-12 col-12">
                        {orderData.length > 0 ? (
                            orderData.slice(0, 50).map((item) => (
                                <div className="order-list" key={item._id}>
                                    <HiShoppingBag className="order-icon" />
                                    <div>
                                        <p><b>{item.status.toUpperCase()}</b><br />
                                            {new Date(item.createdAt).toLocaleDateString("en-IN", { day: "numeric", month: "long" })} • 
                                            {item.items.length} {item.items.length > 1 ? 'Items' : 'Item'} • ₹{item.totalAmount}
                                        </p> 
                                    </div>
                                    <Link className='prod-button' to={`/order-details/${item._id}`}>DETAILS</Link>
                                </div>
                            ))
                        ) : (
                            <div className="text-center mt-4">
                                <div className="spinner-border text-danger" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
             <div className="mt-5 pt-5 mb-5"></div>
             <ToastContainer/>
        </Fragment>
    );
}

export default MyOrdersPage;
